// extracted by mini-css-extract-plugin
export var inlineLink = "_5q-0";
export var inlineLinkButton = "_5q-1";